import { module } from 'angular';
import { AdditionalInfoModalComponent } from './additional-info-modal.component';

export const AdditionalInfoModalModule = module('app.components.modals.additional-info-modal', [])
  .component('additionalInfoModal', AdditionalInfoModalComponent)
  .name;



// WEBPACK FOOTER //
// ./app/components/modals/additional-info-modal/additional-info-modal.module.ts